import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/language-context";

export function WhatsAppContact() {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 to-blue-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-gradient-to-br from-green-500 to-green-600 rounded-3xl shadow-2xl overflow-hidden">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center p-12">
              {/* Left Side - Text Content */}
              <div className="text-white">
                <h2 className="text-3xl md:text-4xl font-bold mb-4">
                  {t("whatsappContact.title")}
                </h2>
                <p className="text-lg text-green-100 mb-6">
                  {t("whatsappContact.subtitle")}
                </p>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full" />
                    <span className="text-green-50">{t("whatsappContact.feature1")}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full" />
                    <span className="text-green-50">{t("whatsappContact.feature2")}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full" />
                    <span className="text-green-50">{t("whatsappContact.feature3")}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-white rounded-full" />
                    <span className="text-green-50">{t("whatsappContact.feature4")}</span>
                  </div>
                </div>
              </div>

              {/* Right Side - QR Code */}
              <div className="flex flex-col items-center">
                <div className="relative w-64 h-64 bg-white rounded-2xl p-4 shadow-xl">
                  <img src="/img/whatsapp二维码.png"
                    alt="WhatsApp QR Code"
                    className="object-contain p-3"
                  style={{width: "100%", height: "100%", objectFit: "cover"}} />
                </div>
                <p className="text-white font-bold text-lg mt-6 text-center">
                  {t("whatsappContact.scanQR")}
                </p>
                <p className="text-green-100 text-sm mt-2 text-center">
                  {t("whatsappContact.workingHours")}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

